import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  connect() {
    this.timer = setTimeout(() => this.element.closest("turbo-frame")?.reload(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
